export default __webpack_public_path__ + "static/media/visual.f67ae906.PNG";